"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EsUsmeUsd = exports.EnUsmeUsd = void 0;
class EnUsmeUsd {
    constructor() {
        this.locale = "en-usme";
        this.dateFormat = {
            short: "M/d/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "(Cn)"
        };
    }
}
exports.EnUsmeUsd = EnUsmeUsd;
class EsUsmeUsd {
    constructor() {
        this.locale = "es-usme";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "(Cn)"
        };
    }
}
exports.EsUsmeUsd = EsUsmeUsd;
